<template>
    <div class="job-board-entry" :class="{current : current}" @click="sendIdParam">
        <!-- <router-link :to="link(uid, title)"> -->
        <div>
            <div class="job-board-entry-logo">
                <div v-if="logo" ><img :src="logo"></div>
            </div>
            <div class="job-board-entry-content">
                <h2>{{title}}</h2>
                <h3>{{company}}</h3>
                 <!--Posted {{prettyDate(created)}} - -->
                <div class="job-board-entry-attributes">
                    <div class="details">
                        <div v-if="city && state" class="location-attribute">{{city}}, {{state}}</div> 
                        <div class="pill employ" v-for="(t, index) in type" :key="index">
                            <div>{{t}}</div> 
                        </div>
                        <div v-if="remote" class="pill remote">Remote</div> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { format } from 'date-fns'

export default {
    name: 'JobBoardListItemPublic',
    props: [ "uid", "logo", "title", "company", "city", "state", "type", "tags", "current", "created", "remote" ],
    methods : {
        prettyDate : created => format(created, "MM/dd"),
        sendIdParam () {
            const q = this.$route.query
            const query = {
                    tags   : q.tags,
                    types  : q.types,
                    state  : q.state,
                    search : q.search,
                    remote : q.remote,
                    id: this.uid
                } 
            this.$router.push({ query })
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "../scss/vars";
    @import "../scss/pill";
    .job-board-entry{
        background-color: white;
        border-radius: $radius;
        margin-bottom: 0.5rem;
        transition: all $speed ease;
        position: relative;
        cursor: pointer;
        &.current{
            z-index: 50;
            @media screen and (min-width: $b1){
                box-shadow: 0 0.25rem 0.5rem rgba( 0, 0, 0, 0.3 );
            }
        }
        &:hover{
            box-shadow: 0 0.25rem 0.5rem rgba( 0, 0, 0, 0.2 );
            z-index: 5;
            position: relative;
            background-color: rgb(240, 246, 255);
        }
        > div {
            // display: block;
            display: flex;
            justify-content: space-between;
            text-decoration: none;
            color: $mid-gray;
            line-height: 1;
        }
        &-logo{
            // background-color: #eee;
            margin: 1rem;
            flex-basis: 6rem;
            height: 6rem;
            flex-grow: 0;
            flex-shrink: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            @media screen and (min-width: $b2){ 
                flex-basis: 10rem;
            }
        }
        &-content{
            flex-grow: 1;
            margin: 1rem 1rem 1rem 0;
            font-size: 1.4rem;
            @media screen and (min-width: $b2){ 
                margin-left: 1rem;
            }
            h3{
                color: $mid-gray;
                margin: 0;
                font-weight: 700;
                font-size: 1.6rem;
                line-height: 1;
                padding: 0.4rem 0;
                @media screen and (min-width: $b2){ 
                    font-size: 1.8rem;
                }
            }
            h2{
                color: $dark-blue;
                font-weight: 700;
                margin: 0;
                padding: 0.4rem 0;
                font-size: 1.8rem;
                line-height: 1;
                @media screen and (min-width: $b2){ 
                    font-size: 2.2rem;
                }
            }
        }
        &-attributes{
            display: flex;
            flex-wrap: wrap;
        }
    }
    .details {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        // margin-top: 1rem;
        > div {
            margin-right: 0.5rem;
        }
    }
</style>